<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Basic Salary

      <employee-profile-payroll-payroll-company-basic-salary-dialog-create
        v-if="!companyEmployee.employee.end_date && $hasPermissionTo(['update employee payroll']) && companyEmployee.company_employee_salaries < 1"
        :company-employee-uid="companyEmployee.company_employee_uid"
        @created="$emit('load')"
      />
    </h4> 

    <v-row
      v-if="companyEmployee.company_employee_salaries.length > 0"
      class="mx-0"
    >
      <v-col>
        <v-row no-gutters>
          <v-col
            cols="2"
            class="text-center"
          >
            <span class="font-weight-bold">Start Date</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center"
          >
            <span class="font-weight-bold">End Date</span>
          </v-col>
          <v-col
            cols="2"
            class="text-right"
          >
            <span class="font-weight-bold">Basic Salary (RM)</span>
          </v-col>
          <v-col cols="5" />
        </v-row>

        <v-row
          v-for="(basicSalary,index) in companyEmployee.company_employee_salaries"
          :key="index"
          no-gutters
        >
          <v-col
            cols="2"
            class="text-center"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ basicSalary.created_by }}</b> on <b>{{ $moment(basicSalary.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ basicSalary.updated_by }}</b> on <b>{{ $moment(basicSalary.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>
            <span>{{ $moment(basicSalary.start_date ).format('DD MMM YYYY') }}</span> 
          </v-col>
          <v-col
            cols="2"
            class="text-center"
          >
            <span>{{ basicSalary.end_date? $moment(basicSalary.end_date).format('DD MMM YYYY'):'N/A' }}</span> 
          </v-col>
          <v-col
            cols="2"
            class="text-right mr-2"
          >
            <span class="pr-3">{{ currencyFormatting(basicSalary.amount) }}</span> 
          </v-col>
          <v-col cols="3">
            <employee-profile-payroll-payroll-company-basic-salary-dialog-edit
              v-if="!companyEmployee.employee.end_date && $hasPermissionTo(['update employee payroll'])"
              :basic-salary="basicSalary"
              :company-employee="companyEmployee"
              :min-start-date="index === companyEmployee.company_employee_salaries.length - 1 ? companyEmployee.start_date : $moment(companyEmployee.company_employee_salaries[index + 1].end_date).add(1,'d').format('YYYY-MM-DD')"
              @updated="$emit('load')"
            />

            <employee-profile-payroll-payroll-company-basic-salary-dialog-delete
              v-if="!companyEmployee.employee.end_date && $hasPermissionTo(['update employee payroll'])"
              :basic-salary="basicSalary"
              @deleted="$emit('load')"
            />
            
            <v-tooltip
              v-if="basicSalary.company_employee_document"
              bottom
            >
              <template v-slot:activator="{ on:tooltip }">
                <v-btn
                  icon
                  small
                  :href="basicSalary.company_employee_document.file_url + '?v=' + $moment().unix()" 
                  target="_blank" 
                  v-on="{...tooltip}"
                >
                  <v-icon color="primary">
                    mdi-email-open
                  </v-icon>
                </v-btn>
              </template>
              <span>View letter</span>
            </v-tooltip>

            <employee-profile-payroll-payroll-company-basic-salary-dialog-increment
              v-if="!companyEmployee.employee.end_date && $hasPermissionTo(['update employee payroll']) && !basicSalary.end_date"
              :basic-salary="basicSalary"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>  

    <v-row
      v-else
      class="mx-0"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyBasicSalaryDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/basic-salary/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyBasicSalaryDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/basic-salary/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyBasicSalaryDialogIncrement: () => import('@/components/hris/employee/profile/payroll/payroll-company/basic-salary/DialogIncrement'),
      EmployeeProfilePayrollPayrollCompanyBasicSalaryDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/basic-salary/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    }, 
    methods: {
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>
